<template>
  <header class="header flex_row">
    <div
      class="system__info flex_row"
    >
      <div class="coll_button" @click="toggle">
        <a-icon style="font-size:16px;vertical-align: middle;" :type="collapsed ? 'menu-unfold' : 'menu-fold'" />
        <span class="coll_button_title">纽尔蓝牙灯后台</span>
      </div>
      <div class="system__info__content flex_row">
        <!-- <div class="message__tips flex_row">
          <div class="message__tips__item flex_row">
            <span class="message__tips__item--FFB841">10</span>
            <span>待批改课程作业</span>
          </div>
          <div class="message__tips__item flex_row">
            <span class="message__tips__item--87DB9B">10</span>
            <span>待批改服务作业</span>
          </div>
          <div class="message__tips__item flex_row">
            <span class="message__tips__item--7D9BE7">10</span>
            <span>待回复作业留言</span>
          </div>
        </div> -->
        <div class="system__info__content__name">
          <p
            style="font-size: 14px;"
          >{{ $store.getters.getUserInfo && $store.getters.getUserInfo.username }}</p>
          <p
            style="font-size: 12px;"
          >{{ $store.getters.getUserInfo && $store.getters.getUserInfo.roleName }}</p>
        </div>
        <div class="action">
          <span @click="handleModal">修改密码</span>
          <img src="@/assets/img/exit.svg" alt="" @click="exit" />
        </div>
        <a-modal title="修改密码" :visible="visible" @cancel="handleCancel" :maskClosable="false" footer>
          <a-form-model  class="ruleForm" ref='ruleForm' :model="formData" v-bind="layout" :rules="rules">
            <a-form-model-item label="现用密码" prop="oldPassword">
              <a-input-password v-model="formData.oldPassword" placeholder="请输入现用密码" />
            </a-form-model-item>
            <a-form-model-item label="新密码" prop="newPassword">
              <a-input-password v-model="formData.newPassword" placeholder="请输入新密码" />
            </a-form-model-item>
            <div style="text-align: center">
              <a-button style="margin-right: 10px;" @click="handleCancel">取消</a-button>
              <a-button type="primary" @click="handleSetPassword">确定</a-button>
            </div>
          </a-form-model>
        </a-modal>





      </div>
    </div>
  </header>
</template>
<script>
import { mapState } from "vuex";
import { logout, modifypwd } from "@/api/index";

export default {
  data() {
    return {
      visible: false,
      oldPwd: "",
      newPwd: "",
      formData: {
        oldPassword: "",
        newPassword: ""
      },
      layout: {
        labelCol: { span: 7 },
        wrapperCol: { span: 14 }
      },
      rules: {
        oldPassword: [{required: true, message: '请输入旧密码'}],
        newPassword: [{required: true, message: '请输入新密码'}],
      }
    };
  },
  computed: {
    ...mapState(["collapsed"])
  },
  created() {

  },
  methods: {
    toggle() {
      this.$store.commit("SET_COLLAPSED", !this.collapsed);
    },
    exit() {

      this.$confirm({
        title: '提示',
        content: '确定退出登录吗',
        okText: '确认',
        cancelText: '取消',
        onOk: () => {
          logout()
            .then(res => {
              if (res.resultStatus) {
                this.$message.success("退出成功");
                localStorage.removeItem("accessToken");
                sessionStorage.removeItem("accessToken");
                this.$router.push("/");
                this.$store.commit("CLEAR_VUEX");
              } else {
                this.$message.warn(res.errorMessage);
              }
            })
            .catch(err => {

              // _this.$message.error("请求失败");
            });
          // localStorage.removeItem("accessToken");
          // this.$router.push("/");
          // this.$store.commit("CLEAR_VUEX");
        }
      });



    },
    handleModal() {
      this.visible = true;
    },
    handleSetPassword(record) {


      if (this.loading) return true;
      this.loading = true;
      this.$refs['ruleForm'].validate(async valid => {
        this.loading = false;
        if (!valid) return false;
        const {oldPassword,newPassword} = this.formData
        // this.formData.oldPassword = md5(this.oldPwd);
        // this.formData.newPassword = md5(this.newPwd);
        modifypwd({
          oldPassword: md5(oldPassword),
          newPassword: md5(newPassword),
        })
          .then(res => {

            if (res.resultStatus) {
              this.$message.success("修改密码成功，请重新登录");
              this.handleCancel();
              this.$router.push("/");
            } else {
              this.$message.warn(res.errmsg);
            }
          })
          .catch(err => {

            // _this.$message.error("请求失败");
          });
      });
    },
    handleCancel() {
      this.oldPwd = "";
      this.newPwd = "";
      this.$refs['ruleForm'].resetFields()
      this.visible = false;

    }
  }
};
</script>

<style lang="less" scoped>
@theme-color: #6ebf89;
@border-color: #dddddd;
.ruleForm {
  width: 380px;
  margin: 0 auto;
}
.shrink--180 {
  width: 180px;
}

.shrink--80 {
  width: 80px;
}

.header {
  height: 60px;
  position: relative;
  left: 0;
  top: 0;
  box-sizing: border-box;
  background: #ffffff;
  overflow: hidden;
  min-width: 1100px;

  .shrink {
    height: 100%;
    justify-content: center;
    background: #2b2b2b;

    &__icon {
      width: 17px;
      height: 17px;
      background: red;
    }
  }

  .system__info {
    height: 100%;
    display: flex;
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
    border-bottom: 1px solid #cccccc;

    &__logo {
      width: 130px;
      height: 60px;
      position: relative;
    }

    .coll_button {
      margin-left: 10px;
      cursor: pointer;

      &_title {
        font-size: 20px;
        font-weight: 500;
        vertical-align: middle;
        display: inline-block;
        margin-left: 20px;
      }
    }

    &__content {
      position: relative;

      .message__tips__item {
        margin-left: 20px;

        span:nth-child(1) {
          font-size: 12px;
          width: 22px;
          height: 22px;
          text-align: center;
          line-height: 22px;
          border-radius: 50%;
          display: block;
          margin-right: 10px;
          color: #fff;
        }

        span:nth-child(2) {
          font-size: 12px;
          color: #666666;
        }

        &--FFB841 {
          background: #168DFF;
        }

        &--87DB9B {
          background: #87db9b;
        }

        &--7D9BE7 {
          background: #7d9be7;
        }
      }

      &__name {
        font-size: 14px;
        color: #333333;
        margin-left: 100px;
        margin-right: 50px;
        cursor: pointer;
      }

      .action {
        height: 20px;
        border-left: 1px solid #eeeeee;
        padding: 0px 50px;

        span {
          font-size: 12px;
          color: #333333;
          position: relative;
          margin-right: 30px;
          cursor: pointer;
        }

        img {
          width: 14px;
          height: 14px;
          cursor: pointer;
        }
      }
    }
  }
}

.flex_row {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.flex_column {
  display: flex;
  flex-direction: column;
}
</style>
